<template>
  <!-- <div v-if="$apollo.loading">
    Carregando...
  </div> -->
  <div class="grid col px-0">

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório de Custo Planejado de Produção
    </div>
    
    <div class="filters" v-if="allPeriods && allPeriods.length >= 0">
      <v-autocomplete
        v-model="periodId"
        label="Selecione o Ciclo"
        :items="allPeriods"
        item-text="name"
        item-value="id"
        @change="fetchProductionCostReportOfPeriod"
        :loading="loading"
        :hint="periodId ? period.additionalInfo : '' "
        persistent-hint
      >
        <template v-slot:item="data">
          <v-list-item-content>
            <v-list-item-title>{{data.item.name}}</v-list-item-title>
            <v-list-item-subtitle>{{data.item.additionalInfo}}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </div>

    <v-tabs
      v-model="tab"
      icons-and-text
      :fixed-tabs="$vuetify.breakpoint.smAndDown"
      color="#37BC9B"
      v-if="productionCostPlanningReport"
    >
      <v-tabs-slider style="display: none"></v-tabs-slider>
      <v-tab>
        Relatório
        <v-icon>mdi-clipboard-text-outline</v-icon>
      </v-tab>
      <v-tab>
        Gráfico
        <!-- <v-icon>mdi-chart-pie</v-icon> -->
        <v-icon>mdi-chart-donut</v-icon>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item class="report fill-height">
        <div class="report-cards" v-if="productionCostPlanningReport">
          <v-card
            outlined
            v-for="(group, index) in productionCostPlanningReport.groups"
            v-bind:key="index"
            :style="`grid-area: card${index + 1}`"
          >
            <div class="card-header">
              <v-card-title> {{ group.name }} </v-card-title>
              <div class="title font-weight-light">
                {{ numberToCurrency(group.cost) }}
              </div>
            </div>
            <v-treeview
              :items="group.items"
              item-children="subItems"
              open-on-click
            >
              <template slot="prepend" slot-scope="{ leaf }"> </template>
              <template slot="append" slot-scope="{ item, leaf }">
                {{ numberToCurrency(item.cost) }}
              </template>
            </v-treeview>
          </v-card>

          <!-- <v-card outlined :style="`grid-area: card4`">
            <div class="card-header">
              <v-card-title>Custo Total</v-card-title>
              <div class="title font-weight-light">
                {{ numberToCurrency(productionCostPlanningReport.totalCost) }}
              </div>
              <v-card-title>Custo por Ha</v-card-title>
              <div class="title font-weight-light">
                {{ numberToCurrency(productionCostPlanningReport.costPerHectare) }}
              </div>
            </div>
          </v-card> -->

          <v-card outlined >
            <div class="card-header">
              <v-card-title>Custo Total</v-card-title>
              <div class="title font-weight-light">
                {{ numberToCurrency(productionCostPlanningReport.totalCost) }}
              </div>
            </div>
          </v-card>

          <v-card outlined >
            <div class="card-header">
              <v-card-title>Custo por Ha</v-card-title>
              <div class="title font-weight-light">
                {{ numberToCurrency(productionCostPlanningReport.costPerHectare) }}
              </div>
            </div>
          </v-card>
        </div>
      </v-tab-item>
      <v-tab-item class="chart fill-height" v-if="productionCostPlanningReport">
        <div class="chart-cards">
          <v-card
            outlined
            v-for="(group, index) in productionCostPlanningReport.groups"
            v-bind:key="index"
            :style="`grid-area: card${index + 1}`"
          >
            <div class="card-header">
              <v-card-title> {{ group.name }} </v-card-title>
              <div class="title font-weight-light">
                {{ numberToCurrency(group.cost) }}
              </div>
            </div>

            <donut-chart
              class="pa-1"
              :chartdata="
                buildChartDataFromArrayOfObjects(
                  group.items,
                  'name',
                  'subItems'
                )
              "
              :options="options"
            >
            </donut-chart>
          </v-card>

          <v-card outlined >
            <div class="card-header">
              <v-card-title>Custo Total</v-card-title>
              <div class="title font-weight-light">
                {{ numberToCurrency(productionCostPlanningReport.totalCost) }}
              </div>
            </div>
          </v-card>

          <v-card outlined >
            <div class="card-header">
              <v-card-title>Custo por Ha</v-card-title>
              <div class="title font-weight-light">
                {{ numberToCurrency(productionCostPlanningReport.costPerHectare) }}
              </div>
            </div>
          </v-card>
        </div>

        <!-- <v-row>
          <v-col cols="12" sm="6"> 
            <v-card outlined>
              <v-card-title class="">
                Custo Total
              </v-card-title>
              <v-card-text>
                {{ numberToCurrency(productionCostPlanningReport.totalCost) }}
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6"> 
            <v-card outlined>
              <v-card-title class="">
                Custo por Ha
              </v-card-title>
              <v-card-text>
                {{ numberToCurrency(productionCostPlanningReport.costPerHectare) }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row> -->
        
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import DonutChart from "@components/shared/charts/DonutChart.js";
import gql from 'graphql-tag'

export default {
  //   mounted: function () {
  //     this.$nextTick(function () {
  //
  //       setTimeout(() => {
  //         // console.log(this.allPeriods[0])
  //     this.autocomplete = this.allPeriods[0]
  //
  // this.autocomplete.trigger('change')
  // // this.$emit('fetchProductionCostReportOfPeriod', this.autocomplete.id)
  //     // this.autocomplete.change()//$dispatch("onChange", this.autocomplete )
  //     // var evt = document.createEvent("HTMLEvents");
  //   // evt.initEvent("change", false, true);
  //   // this.autocomplete.$dispatc('change')
  //     // this.autocomplete.fireEvent("onchange");
  // },2000);
  //
  //
  //     })
  //   },
  components: {
    DonutChart
  },
  data() {
    return {
      autocomplete: null,
      productionCostPlanningReport: null,
      allPeriods: [],
      periodId: null,
      period: null,
      loading: true,
      tab: null,
      data: {
        datasets: [
          {
            // backgroundColor: [
            //   "#3366CC",
            //   "#DC3912",
            //   "#FF9900",
            //   "#109618",
            //   "#990099",
            //   "#3B3EAC"
            // ],
            // hoverBackgroundColor: [
            //   "#3366CC",
            //   "#DC3912",
            //   "#FF9900",
            //   "#109618",
            //   "#990099",
            //   "#3B3EAC"
            // ],
            data: [0.0, 0.0, 8.31, 10.43, 84.69, 0.84]
          },
          {
            // backgroundColor: [
            //   "#3366CC",
            //   "#DC3912",
            //   "#FF9900",
            //   "#109618",
            //   "#990099",
            //   "#3B3EAC"
            // ],
            // hoverBackgroundColor: [
            //   "#3366CC",
            //   "#DC3912",
            //   "#FF9900",
            //   "#109618",
            //   "#990099",
            //   "#3B3EAC"
            // ],
            data: [8.31, 95.96]
          }
        ],
        labels: [
          "resource-group-1",
          "resource-group 2",
          "Data Services - Basic Database Days",
          "Data Services - Basic Database Days",
          "Azure App Service - Basic Small App Service Hours",
          "resource-group-2 - Other"
        ]
      },
      options: {
        maintainAspectRatio: false,
        legend: {
          position: "bottom"
        },
        plugins: {
          colorschemes: {
            scheme: "brewer.SetThree12"
          }
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var meta = dataset._meta[Object.keys(dataset._meta)[0]];
              var total = meta.total;
              var currentValue = dataset.data[tooltipItem.index];
              var percentage = parseFloat(
                ((currentValue / total) * 100).toFixed(1)
              );
              return currentValue + " (" + percentage + "%)";
            },
            title: function(tooltipItem, data) {
              return data.labels[tooltipItem[0].index];
            }
          }
        }
      }
    };
  },
  created(){
    this.fetchAllPeriods()
  },
  methods: {
    buildChartDataFromArrayOfObjects: function(
      itemsArray,
      itemField,
      childrenArrayName
    ) {
      var subItemsArray = itemsArray
        .map(function(obj) {
          return obj[childrenArrayName].map(function(children) {
            return children;
          });
        })
        .flat();

      // console.log(subItemsArray)

      var labels = this.mapFieldFromArrayOfObjects(itemsArray, "name");

      var data = this.mapFieldFromArrayOfObjects(itemsArray, "cost");
      // var data2 = this.mapFieldFromArrayOfObjects(subItemsArray, "cost")
      // console.log(data);
      // console.log(data2)

      var result = {
        datasets: [
          {
            data: data
          }
          // {
          //   data: data2
          // }
        ],
        labels: labels
      };
      // console.log(result)
      return result;
    },
    mapFieldFromArrayOfObjects: function(array, fieldName) {
      return array.map(function(obj) {
        return obj[fieldName];
      });
    },
    buildChartLabelsFromArrayOfObjects: function(
      itemsArray,
      itemsField,
      childrenArray
    ) {
      var itemLabels = itemsArray.map(function(obj) {
        return obj[itemsField];
      });

      var childrenLabels = childrenArray.map(function(obj) {
        return obj[itemsField];
      });

      return itemLabels.concat(childrenLabels);
    },
    fetchAllPeriods: function() {
      this.loading = true;
      this.allPeriods = null;
      this.$apollo
        .query({
          query: ALL_PERIODS_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.allPeriods = response.data.accountContext.allPeriods;
          // console.log("this.allPeriods", this.allPeriods);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    fetchProductionCostReportOfPeriod: function(periodId) {
      // periodId = periodId.id
      this.loading = true;
      this.period = this.allPeriods.find(obj => obj.id == this.periodId);
      this.productionCostPlanningReport = null;
      this.$apollo
        .query({
          query: PRODUCTION_COST_REPORT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            periodId: periodId
          }
        })
        .then(response => {
          this.productionCostPlanningReport = response.data.accountContext.productionCostPlanningReport;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    numberToCurrency: function(number) {
      return new Intl.NumberFormat("pt-br", {
        style: "currency",
        currency: "BRL"
      }).format(number);
    }
  }
};

const ALL_PERIODS_QUERY = gql `
  query {
    accountContext{
      allPeriods {
        id
        name
        additionalInfo
      }  
    }
  }
`;

const PRODUCTION_COST_REPORT_QUERY = gql `
  query ($periodId: ID!){
    accountContext{
      productionCostPlanningReport(periodId: $periodId) {
        totalCost
        costPerHectare
        groups {
          name
          cost
          items {
            name
            cost
            subItems {
              name
              cost
            }
          }
        }
      }
    }
  }
`;

</script>

<style lang="scss" scoped>
.grid {
  height: 100%;
  display: grid;
}

.report-cards,
.chart-cards {
  height: 100%;
  display: grid;
  grid-area: report-cards;
}

.filters {
  grid-area: filters;
}

.v-tabs {
  grid-area: tabs;
}

.v-tabs-items {
  grid-area: tabs-items;
  height: 100%;
}

.card-header {
  display: flex;
  align-items: center;
}

@media (min-width: 640px) {
}
.grid {
  grid-template-columns: 100%;
  grid-template-rows: auto auto 1fr;
  grid-template-areas:
    "filters"
    "tabs"
    "tabs-items";
}

.report-cards,
.chart-cards {
  grid-gap: 10px;
  grid-template-columns: 100%;
  grid-template-areas:
    "card1"
    "card2"
    "card3"
    "card4";
}
@media (min-width: 768px) {
}

@media (min-width: 1024px) {
  .grid {
    grid-template-columns: minmax(100px, 1fr) minmax(100px, 1fr) minmax(
        100px,
        1fr
      );
    grid-template-rows: auto auto 1fr;
    grid-template-areas:
      ". filters ."
      "tabs tabs tabs"
      "tabs-items tabs-items tabs-items";
  }

  .report-cards,
  .chart-cards {
    grid-gap: 10px;
    grid-template-columns: minmax(100px, 1fr) minmax(100px, 1fr) minmax(
        100px,
        1fr
      );
    grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
    grid-template-areas:
      "card1 card2 card3"
      "card1 card2 card3"
      "card1 card2 card3"
      "card1 card2 card3"
      "card4 card4 card4";
  }

  .v-card {
    display: flex;
    flex-direction: column;
  }

  .v-treeview {
    flex-basis: 0;
    flex-grow: 1;
    overflow-y: auto;
  }
}

@media (min-width: 1280px) {
}
</style>
